import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Section, FeedbackQuestions } from '../s'
import { H1 as Title } from 'components/typography/heading'
import Paragraph from 'components/typography/paragraph'

const NetvisorAbout = ({ name }) => (
    <Section>
        <Title>
            <FormattedMessage
                id="integration_heading_about"
                defaultMessage="About {service}"
                values={{ service: name }} />
        </Title>
        <Paragraph>
            <FormattedMessage
                id="integration_netvisor_preamble_about"
                defaultMessage="Save time and increase data quality by connecting to Netvisor – a simple way to import and synchronize people between your organization in Huma and your Netvisor account." />
        </Paragraph>
        <FeedbackQuestions />
    </Section>
)

export default NetvisorAbout